import { getSavedSearch } from './savedSearch';

export const useGetredirectLink = () => {
  return (path: string, id?: string, searchString?: string, rowIndex?: number) => {
    const savedSearch = getSavedSearch();
    const savedSearchString = searchString ?? savedSearch?.savedSearch;
    const savedFilterKey = savedSearch?.savedFilterData.filterKey;
    const savedFilterName = savedSearch?.savedFilterData?.filterName;
    const parentCustomerId =
      new URL(window.location.href).searchParams.get('parentCustomerId') ?? '';
    const parentAccountNumber =
      new URL(window.location.href).searchParams.get('parentAccountNumber') ?? '';
    const invoiceToAccountNumber =
      new URL(window.location.href).searchParams.get('invoiceToAccountNumber') ?? '';
    const invoiceToAccountId =
      new URL(window.location.href).searchParams.get('invoiceToAccountId') ?? '';
    const poNumber = new URL(window.location.href).searchParams.get('poNumber') ?? '';
    const poCurrency = new URL(window.location.href).searchParams.get('poCurrency') ?? '';

    let route = `${path}/${id}?`;
    if (parentCustomerId) {
      route =
        route + `&parentCustomerId=${parentCustomerId}&parentAccountNumber=${parentAccountNumber}`;
    }

    if (savedFilterName) {
      route = route + `&filterKey=${savedFilterKey}&filterName=${savedFilterName}`;
    }

    if (savedSearchString) {
      route = route + `&search=${savedSearchString}`;
    }

    if (invoiceToAccountNumber && invoiceToAccountId && poNumber && poCurrency) {
      route =
        route +
        // eslint-disable-next-line max-len
        `&invoiceToAccountNumber=${invoiceToAccountNumber}&invoiceToAccountId=${invoiceToAccountId}&poNumber=${poNumber}&poCurrency=${poCurrency}`;
    }

    route = route + `&rowIndex=${rowIndex}`;
    return route;
  };
};
